export const Default_style = {
  rootSx: {},
  SearchSelectSx: {
    backgroundColor: '#F7F7F7 ',
    // zIndex: 200,
    boxSizing: 'border-box',
    // position: 'fixed',
    width: '100%',
    display: 'grid',
    // inset: '142px auto auto auto',
  },
  textFieldStyle: {
    width: '100%',
    marginTop: '4px',
    '& .MuiInputBase-root': { backgroundColor: '#fff', borderRadius: '8px' },
    '& .MuiOutlinedInput-input': {
      width: '100%',
      fontSize: '14px',
      fontWeight: '500',
    },
  },
  filterIconSx: {
    border: '1px solid #DBEAE8',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    height: '38px',
    width: '40px',
    ml: 'auto',
    cursor: 'pointer',
    mt: 0.4,
  },
  drawerSx: {
    '& .MuiDrawer-paperAnchorBottom': {
      boxSizing: 'border-box',
      maxWidth: {
        sm: 428,
      },
      right: 1,
      mx: {
        sm: 'auto',
      },
      borderRadius: '24px 24px 0px 0px',
    },
    p: 2.5,
  },
  cancelBtnSx: {
    textTransform: 'none',
    backgroundColor: '#F3F0FF',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: '#F3F0FF',
    },
  },
  applyBtnSx: {
    textTransform: 'none',
  },

  drawerTitleSx: {
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0px',
    color: '#5C6266',
    py: 1,
  },
  buttonactivenumSX: {
    border: '1px solid',
    minWidth: '36px',
    minHeight: '40px',
    borderRadius: '10px',
    padding: '5px 10px',
    backgroundColor: '#EE8438',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#EE8438',
      color: '#fff',
    },
  },
  buttoninactivenumSX: {
    border: '1px solid ',
    borderColor: '#E3E3E3',
    borderRadius: '10px',
    minWidth: '36px',
    minHeight: '40px',
    padding: '5px 10px',
    color: '#5C6266',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#5C6266',
    },
  },
};
